import { SkyttaComponentIds } from './SkyttaComponentIds';
import type { ComponentDeserializer, JsonElement, SerializableComponent } from '@inter-ikea-core/core';

const componentSerializationKey = 'CustomOutlineComponent';

export class CustomOutlineComponentDeserializer implements ComponentDeserializer {
  thisClassIsGuaranteedToNotModifyOrQueryCoreState = true;
  canHandle(serializationKey: string) {
    return serializationKey === componentSerializationKey;
  }

  deserialize(serializationKey: string, json: any) {
    const data: CustomOutlineComponent = JSON.parse(json.toString());

    switch (serializationKey) {
      case componentSerializationKey:
        return new CustomOutlineComponent(data.viewerId);
    }
    return null;
  }
}

/**
 * Placed on all entities that are panels
 */

export class CustomOutlineComponent implements SerializableComponent {
  /**
   *
   */
  public readonly typeId: number = SkyttaComponentIds.CustomOutlineComponentId;
  public readonly serializable: boolean = true;
  public readonly doStoreInSnapshot: boolean = true;
  public readonly viewerId: number;

  constructor(viewerId: number) {
    this.viewerId = viewerId;
  }

  serializationKey(): string {
    return componentSerializationKey;
  }

  toJson(parse: (json: string) => JsonElement): JsonElement {
    return parse(JSON.stringify(this));
  }

  /**
   * Comparison for entity manager.
   * @param _other
   * @returns
   */
  public eq(other: CustomOutlineComponent): boolean {
    return this.viewerId === other.viewerId;
  }
}
